import axios from "axios";
const _axios = axios.create({
  baseURL: "https://api.activity-maps.com/",
});
const checkfortoken = (config) => {
  let token = localStorage.getItem("accessToken");
  return token;
};
const getRefreshToken = () => {
  let token = localStorage.getItem("refreshToken");
  return token;
};
const getContentType = (config) => {
  if (config?.data instanceof FormData) return "multipart/form-data";
  else
    return config?.data?.file ||
      config?.data?.files ||
      config?.data?.["video-file"]
      ? "multipart/form-data"
      : "application/json";
};
_axios.interceptors.request.use((config) => {
  const token = checkfortoken();
  const contentType = getContentType(config);
  const isFormData = config.data instanceof FormData;



if(config?.method?.toUpperCase()!=="GET"||config?.data)
window.dispatchEvent(new CustomEvent("FETCH-CYCLE",{detail:{isOpen:true,isFileUpload:isFormData}}));

  // Don't mutate FormData — just pass it through
  const modified = {
    ...config,
    headers: {
      ...config.headers,
      authorization: `Bearer ${token}`,
      "Content-Type": contentType,
    },
    data: isFormData
      ? config.data // ✅ Leave it untouched if it's FormData
      : {
        ...config.data,
        refreshToken: getRefreshToken(),
      },
  };
  return modified;
});

_axios.interceptors.response.use((res) => {
  window.dispatchEvent(new CustomEvent("FETCH-CYCLE",{detail:{isOpen:false}}));
  return res;
},(e)=>{
  window.dispatchEvent(new CustomEvent("FETCH-CYCLE",{detail:{isOpen:false}}));
  return e;
});

export default _axios;
